module.exports = __webpack_public_path__ + "static/img/15.7b600e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/eng/15.png
// module id = AZxe
// module chunks = 0